// @ts-ignore - no types for ar-feature-gating
import { splitClient } from '@nextroll/ar-feature-gating';

export const loadSplitIo = (onSplitClientReady: () => void = () => {}) => {
    // As user/advertisable information is not yet available on signin/signup, we use placeholders.
    splitClient.load({
        environment: process.env.ENVIRONMENT,
        advertisable: {
            eid: 'ALL_USERS',
            organization: 'ORG_EID',
            business_unit: 'BUSINESS_UNIT',
        },
        user: {
            eid: 'USER_EID',
        },
        actualUser: {
            eid: 'ACTUAL_USER_EID',
        },
    });

    splitClient.on(splitClient.READY_EVENT, onSplitClientReady);
};

export const getTreatment = (feature: string) =>
    splitClient.getTreatment(feature);
